import { useEffect, useState } from 'react';
import { getPublicPost } from '../../lib/api';
import { applyItemMetadata } from '../../app/seo';
import { BlockRenderer, mediaUrl } from '../components/BlockRenderer';
import { formatPostDate } from '../components/PostList';
import { NotFoundPage } from './NotFoundPage';
import type { CustomPage } from '../../lib/types';

export function PostPage({ slug }: { slug: string }) {
  const [post, setPost] = useState<CustomPage | null | undefined>(undefined);

  useEffect(() => {
    getPublicPost(slug).then(setPost).catch(() => setPost(null));
  }, [slug]);

  useEffect(() => {
    if (post) applyItemMetadata(`/blog/${post.slug}`, post.title, post.summary);
  }, [post]);

  if (post === undefined) {
    return <section className="not-found" aria-label="Loading post"><p>Loading…</p></section>;
  }

  if (!post) return <NotFoundPage />;

  return (
    <article>
      <header className={`page-hero${post.heroImageId ? ' page-hero--image' : ''}`} style={post.heroImageId ? { backgroundImage: `url(${mediaUrl(post.heroImageId)})` } : undefined}>
        <h1>{post.title}</h1>
        <p className="page-hero__lead">{formatPostDate(post.publishedAt)}{post.category && ` · ${post.category}`}</p>
      </header>
      <section className="prose"><BlockRenderer blocks={post.blocks} /></section>
    </article>
  );
}
